module.exports = __webpack_public_path__ + "img/external-links-err-img.4dfddddf.png";